// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

// Selectors
import { assets$ } from 'fc-assets'


export default function (job) {
  return createSelector(
    [
      assets$,
    ],
    (assets: Object) => {
      if (job) {
        const subfieldObj = _find(assets, (asset) => {
          return asset.id === job.subfield
        })
        if (subfieldObj) {
          const fieldObj = _find(assets, (asset) => {
            return asset.id === subfieldObj.parent
          })
          if (fieldObj) {
            return fieldObj
          }
        }
      }

      return null
    }
  )
}
